/* eslint-disable */
export function proofHeader() {
    const match = document.cookie.match(/(?:^|;\s*)widget_proof=([^;]+)/);
    return match ? { 'X-Widget-Proof': decodeURIComponent(match[1]) } : {};
}

export function authHeader() {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.token) {
        return { 'Authorization': 'Bearer ' + user.token, ...proofHeader() };
    } else {
        return { ...proofHeader() };
    }
}

export function logout() {
    localStorage.removeItem('user');
}

export function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload();
            }
            
            const error = (data && data.Message) || response.statusText;
            return Promise.reject(error);
        }
        if(data && data.hasError)
        {
            return Promise.reject(data.errorMessage);
        }
        
        return data;
    });
}